'use client';

import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useProductSelectionCheckoutAndCartCheckoutFlags } from '../product-selection/hooks/useProductSelectionCheckoutAndCartCheckoutFlags';

export const AdditionalDisclaimer = () => {
  const flags = useProductSelectionCheckoutAndCartCheckoutFlags();

  if (flags.isTwoMonthTrialWith50PctOff) {
    return (
      <Typography size="meta">
        *50% off a 2-month supply. Applies only to your first shipment. Subject
        to consultation. New subscribers only.
      </Typography>
    );
  }

  return null;
};
